var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackImage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 117,
    viewBox: "0 0 234 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.999 58.4992V43.8735L131.625 58.4992L116.999 73.1248V58.4992Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 117V102.374L131.625 117H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 102.374L131.625 87.7502L146.25 102.374H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.625 87.7504L146.25 73.1248L160.876 87.7504H131.625Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25 73.1246L160.876 58.499L175.502 73.1246H146.25Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 87.7502V102.374L131.625 87.7502H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 73.1248L131.625 87.7504L146.25 73.1248H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.625 58.499L146.25 73.1246L160.876 58.499H131.625Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 -0.00341797V14.6222L131.625 -0.00341797H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 14.6223L131.625 29.2479L146.25 14.6223H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.625 29.2478L146.25 43.8734L160.876 29.2478H131.625Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25 43.8735L160.876 58.4992L175.502 43.8735H146.25Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 29.2479V14.6223L131.625 29.2479H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 43.8734L131.625 29.2478L146.25 43.8734H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.625 58.4992L146.25 43.8735L160.876 58.4992H131.625Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.718 73.1246L206.086 58.499H160.876L175.502 73.1246",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.718 43.8735L206.086 58.4992H160.876L175.502 43.8735",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.001 59.76L234.004 59.76V57.2362L117.001 57.2362V59.76Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 58.4992V43.8735L102.374 58.4992L116.999 73.1248V58.4992Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 117V102.374L102.374 117H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 102.374L102.374 87.7502L87.7496 102.374H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.374 87.7504L87.7496 73.1248L73.124 87.7504H102.374Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7495 73.1246L73.1239 58.499L58.4983 73.1246H87.7495Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 87.7502V102.374L102.374 87.7502H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 73.1248L102.374 87.7504L87.7496 73.1248H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.374 58.499L87.7496 73.1246L73.124 58.499H102.374Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 -0.00341797V14.6222L102.374 -0.00341797H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 14.6223L102.374 29.2479L87.7496 14.6223H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.374 29.2478L87.7496 43.8734L73.124 29.2478H102.374Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7495 43.8735L73.1239 58.4992L58.4983 43.8735H87.7495Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 29.2479V14.6223L102.374 29.2479H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 43.8734L102.374 29.2478L87.7496 43.8734H116.999Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.374 58.4992L87.7496 43.8735L73.124 58.4992H102.374Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2821 73.1246L27.9145 58.499H73.124L58.4984 73.1246",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2821 43.8735L27.9145 58.4992H73.124L58.4984 43.8735",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.999 57.2363H-0.00415039V59.7601H116.999V57.2363Z",
    fill: "#FDF8ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackImage1);
export default __webpack_public_path__ + "static/media/backImage1.f0ec77412c7ab422826fcc285f7e5c39.svg";
export { ForwardRef as ReactComponent };